import $ from 'jquery';

$(function () {
  $('.back').on('click', function (e) {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: 0,
    }, 500);
  });

});


